export default "__VITE_ASSET__C0Iz8d4A__"